import { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import '../../styles/pages/Admin/Authentication.scss';
import SERVER from '../../hooks/useServer';

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();
    
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [verifying, setVerifying] = useState(true);
    const [tokenValid, setTokenValid] = useState(false);

    useEffect(() => {
        const verifyToken = async () => {
            if (!token) {
                toast.error('Token manquant');
                setVerifying(false);
                return;
            }

            try {
                const response = await axios.get(`${SERVER}/auth/verify-reset-token/${token}`);
                if (response.data.valid) {
                    setTokenValid(true);
                }
            } catch (err) {
                toast.error(err.response?.data?.error || 'Token invalide ou expiré');
                setTokenValid(false);
            } finally {
                setVerifying(false);
            }
        };

        verifyToken();
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!newPassword || !confirmPassword) {
            toast.error('Veuillez remplir tous les champs');
            return;
        }

        if (newPassword.length < 6) {
            toast.error('Le mot de passe doit contenir au moins 6 caractères');
            return;
        }

        if (newPassword !== confirmPassword) {
            toast.error('Les mots de passe ne correspondent pas');
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(`${SERVER}/auth/reset-password`, {
                token,
                newPassword
            });
            toast.success(response.data.message);
            setTimeout(() => {
                navigate('/admin/login');
            }, 2000);
        } catch (err) {
            toast.error(err.response?.data?.error || 'Échec de la réinitialisation du mot de passe');
        } finally {
            setLoading(false);
        }
    };

    if (verifying) {
        return (
            <div className='auth'>
                <div className="auth-container">
                    <div className="auth-header">
                        <h1>Vérification...</h1>
                    </div>
                </div>
            </div>
        );
    }

    if (!tokenValid) {
        return (
            <div className='auth'>
                <div className="auth-container">
                    <div className="auth-header">
                        <h1>Lien invalide</h1>
                        <h3>Ce lien de réinitialisation est invalide ou a expiré</h3>
                    </div>
                    <div className="back-link" style={{ textAlign: 'center', marginTop: '20px' }}>
                        <Link to="/admin/forgot-password">Demander un nouveau lien</Link>
                    </div>
                </div>
                <ToastContainer position="bottom-right" autoClose={3000} />
            </div>
        );
    }

    return (
        <div className='auth'>
            <div className="auth-container">
                <div className="auth-header">
                    <h1>Réinitialiser le mot de passe</h1>
                    <h3>Entrez votre nouveau mot de passe</h3>
                </div>

                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-group">
                        <label htmlFor="newPassword">Nouveau mot de passe</label>
                        <input
                            type="password"
                            id="newPassword"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Entrez votre nouveau mot de passe"
                            required
                            disabled={loading}
                            minLength={6}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirmez votre mot de passe"
                            required
                            disabled={loading}
                            minLength={6}
                        />
                    </div>

                    <button 
                        type="submit" 
                        disabled={loading} 
                        className={`auth-button ${loading ? 'loading' : ''}`}
                    >
                        {loading ? (
                            <>
                                <span className="spinner"></span>
                                Réinitialisation...
                            </>
                        ) : (
                            'Réinitialiser le mot de passe'
                        )}
                    </button>

                    <div className="back-link">
                        <Link to="/admin/login">← Retour à la connexion</Link>
                    </div>
                </form>
            </div>
            <ToastContainer position="bottom-right" autoClose={3000} />
        </div>
    );
};

export default ResetPassword;
